module.exports = __webpack_public_path__ + "static/media/icnOjoAbierto.9857df3c.svg";